export const hasPermissionId = (roles: any[], id: number): boolean => {
  return roles.some((role) => role.id === id);
};